import store from "@/store";
import DepService from "@/services/depService";
import UserSessionFunctions from "@/functions/userSessionFunctions";
import {apiConfig} from "@/config";

const ENTITLED_STATUS_NAMES = new Set(['ACTIVE', 'GRACE', 'SUSPENDED']);

const SIGNED_PARAM_NAMES = [
    'sigts',
    'sigv1',
    'depserviceid',
    'bpSvc',
    'msisdn',
    'result',
    'result_id',
    'subscription_id',
    'channel',
    'ext_ref',
];

export function isMyBundleEntry(rawQueryString = window.location.search) {
    return /[?&]sigv1=/.test(rawQueryString);
}

export async function handleMyBundleEntry() {
    let data;

    try {
        data = await DepService.validateMyBundleEntry(apiConfig.productId, window.location.search);
    } catch (error) {
        console.log('My Bundle entry request failed', error);
        stripSignedParams();
        return {entered: false, reason: 'REQUEST_FAILED'};
    }

    stripSignedParams();

    if (!data?.result) {
        console.log(`My Bundle entry rejected: ${data?.reason ?? 'NO_RESULT'}`);
        return {entered: false, reason: data?.reason ?? 'NO_RESULT'};
    }

    const user = data.user;
    const signedResult = String(data.entry?.result ?? '').trim().toUpperCase();
    const localStatus = String(user?.statusName ?? '').trim().toUpperCase();

    if (!user || (!ENTITLED_STATUS_NAMES.has(signedResult) && !ENTITLED_STATUS_NAMES.has(localStatus))) {
        console.warn(`My Bundle entry not entitled: result=${data.entry?.result} statusName=${user?.statusName}`);
        return {entered: false, reason: 'NO_ENTITLEMENT', statusName: user?.statusName};
    }

    UserSessionFunctions.setUserSesssionHasLoggedIn(true);
    UserSessionFunctions.setUserSesssionMsisdn(user.msisdn);
    store.commit('setUser', {user});
    store.commit('setMyBundle', true);
    if (typeof user.statusName === 'string') {
        store.commit('setSubscriptionStatus', user.statusName.toUpperCase());
    }

    return {entered: true, user};
}

export function redirectToMyBundleLanding() {
    const landingUrl = apiConfig.myBundleLandingUrl;
    if (!landingUrl) return false;
    window.location.assign(landingUrl);
    return true;
}

function stripSignedParams() {
    const params = new URLSearchParams(window.location.search);
    SIGNED_PARAM_NAMES.forEach((name) => params.delete(name));

    const query = params.toString();
    const url = `${window.location.pathname}${query ? `?${query}` : ''}${window.location.hash}`;
    window.history.replaceState({}, document.title, url);
}
